import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IAchivements } from 'app/shared/model/achivements.model';
import { getEntities as getAchivements } from 'app/entities/achivements/achivements.reducer';
import { IPointAllocationSystem } from 'app/shared/model/point-allocation-system.model';
import { PointAllocationTypes } from 'app/shared/model/enumerations/point-allocation-types.model';
import { getEntity, updateEntity, createEntity, reset } from './point-allocation-system.reducer';

export const PointAllocationSystemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const achivements = useAppSelector(state => state.achivements.entities);
  const pointAllocationSystemEntity = useAppSelector(state => state.pointAllocationSystem.entity);
  const loading = useAppSelector(state => state.pointAllocationSystem.loading);
  const updating = useAppSelector(state => state.pointAllocationSystem.updating);
  const updateSuccess = useAppSelector(state => state.pointAllocationSystem.updateSuccess);
  const pointAllocationTypesValues = Object.keys(PointAllocationTypes);

  const handleClose = () => {
    navigate('/point-allocation-system' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAchivements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...pointAllocationSystemEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          pointType: 'Referral',
          ...pointAllocationSystemEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.pointAllocationSystem.home.createOrEditLabel" data-cy="PointAllocationSystemCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.pointAllocationSystem.home.createOrEditLabel">
              Create or edit a PointAllocationSystem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="point-allocation-system-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.pointAllocationSystem.pointType')}
                id="point-allocation-system-pointType"
                name="pointType"
                data-cy="pointType"
                type="select"
              >
                {pointAllocationTypesValues.map(pointAllocationTypes => (
                  <option value={pointAllocationTypes} key={pointAllocationTypes}>
                    {translate('fivePlusApp.PointAllocationTypes.' + pointAllocationTypes)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('fivePlusApp.pointAllocationSystem.userPoint')}
                id="point-allocation-system-userPoint"
                name="userPoint"
                data-cy="userPoint"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/point-allocation-system" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PointAllocationSystemUpdate;
